<template>
  <div>
    <div style="display: flex; justify-content: flex-start; align-items: center">
      <h2 class="mb-4">Administrator Email List</h2>
    </div>
    <v-card>
      <v-data-table :headers="fieldList" :items="entityList" sort-by="id" :search="keyword" :footer-props="{ itemsPerPageOptions: [50, 100, 500, -1] }">
        <template v-slot:top>
          <v-row no-gutters style="padding: 5px 0 0 0">
            <v-col></v-col>
            <v-col cols="12" sm="6">
              <div class="d-flex px-2">
                <v-text-field v-model="keyword" append-icon="mdi-magnify" label="Search" hide-details style="margin-right: 10px"></v-text-field>
                <v-btn color="primary" class="mt-4" @click="showAdd">Add Administrator Email</v-btn>
              </div>
            </v-col>
          </v-row>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn fab x-small @click="showEdit(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn fab x-small style="margin-left: 10px" @click="showDelete(item.id)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        <template v-slot:no-data>Empty list</template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialogAdd.show" max-width="500">
      <v-card>
        <v-card-title>{{ dialogAdd.title }}</v-card-title>

        <v-form class="px-5">
          <v-text-field v-model="entityAdd.email" label="Email"></v-text-field>
        </v-form>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogAdd.show = false">Cancel</v-btn>
          <v-btn color="primary" @click="add">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEdit.show" max-width="500">
      <v-card>
        <v-card-title>{{ dialogEdit.title }}</v-card-title>

        <v-form class="px-5">
          <v-text-field v-model="entityEdit.email" label="Email"></v-text-field>
        </v-form>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogEdit.show = false">Cancel</v-btn>
          <v-btn color="primary" @click="edit">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDelete.show" max-width="500">
      <v-card>
        <v-card-title>{{ dialogDelete.title }}</v-card-title>

        <v-card-text class="px-5">{{ dialogDelete.content }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogDelete.show = false">Cancel</v-btn>
          <v-btn color="accent" @click="remove">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import axios from "axios";

export default {
  data() {
    return {
      dialogAdd: { show: false, title: "Add New Administrator Email" },
      dialogEdit: { show: false, title: "Edit Administrator Email" },
      dialogDelete: {
        show: false,
        title: "Delete Administrator Email",
        content: "Are you sure you want to delete this administrator email?"
      },
      entityAdd: {},
      entityEdit: {},
      entityDelete: {},
      entityList: [],
      tenant: {},
      fieldList: [
        { text: "Id", value: "id" },
        { text: "Email", value: "email" },
        { text: "", value: "action", sortable: false }
      ],
      keyword: ""
    };
  },
  mounted: function () {
    this.list();
  },
  methods: {
    list() {
      axios
        .get("/system/administratoremail/list")
        .then((response) => {
          this.entityList = response.data;
        })
        .catch(() => {});
    },
    showAdd() {
      this.entityAdd = {};
      this.dialogAdd.show = true;
    },
    add() {
      axios
        .post("/system/administratoremail/add", {
          entity: this.entityAdd
        })
        .then((response) => {
          this.list();
          this.dialogAdd.show = false;
        })
        .catch(() => {});
    },
    showEdit(entity) {
      this.entityEdit = {
        id: entity.id,
        email: entity.email
      };
      this.dialogEdit.show = true;
    },
    edit() {
      axios
        .post("/system/administratoremail/edit", {
          entity: this.entityEdit
        })
        .then((response) => {
          this.dialogEdit.show = false;
          this.list();
        })
        .catch(() => {});
    },
    showDelete(entityId) {
      this.entityDelete.id = entityId;
      this.dialogDelete.show = true;
    },
    remove() {
      axios
        .post("/system/administratoremail/delete", { id: this.entityDelete.id })
        .then((response) => {
          this.list();
          this.dialogDelete.show = false;
        })
        .catch(() => {});
    }
  }
};
</script>
